/*
Copyright 2026 Element Creations Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

/** The call-event transport granted by native Element Call widget hosts. */
export const ElementCallReactionEventType = "io.element.call.reaction";
